// import Placeholder from 'cloudinary-react/lib/components/Placeholder'
// import Transformation from 'cloudinary-react/lib/components/Transformation'
import PropTypes from 'prop-types'
import React from 'react'
import settings from '@nobia/zeus-components/lib/settings'
import { Image as CloudinaryImg } from 'cloudinary-react'
import { pure } from 'recompose'
import { Cloudinary } from 'cloudinary-core'

const cld = new Cloudinary({
  cloud_name: settings.cloudinary.cloudName,
  secure: true,
})

export const createCloudinaryUrl = (publicId, transformation) =>
  cld.url(publicId, transformation)

const Image = ({ publicId, keepDefaultScale, borderRadius, ...props }) => (
  <CloudinaryImg
    key={publicId}
    alt={
      publicId?.endsWith('/')
        ? publicId?.split('/')[-2]
        : publicId?.split('/')[-1]
    }
    cloudName={settings.cloudinary.cloudName}
    publicId={publicId}
    borderradius={borderRadius}
    dpr="auto"
    responsiveUseBreakpoints="true"
    responsive
    loading="lazy"
    {...props}
  >
    {/* {!keepDefaultScale && (
      <Transformation rawTransformation="h_200,w_300,c_scale" />
    )} */}
    {/* <Placeholder type="pixelated" /> */}
  </CloudinaryImg>
)

Image.defaultProps = {
  borderRadius: '',
  keepDefaultScale: false,
}

Image.propTypes = {
  publicId: PropTypes.string.isRequired,
  borderRadius: PropTypes.string,
  keepDefaultScale: PropTypes.bool,
}

const PureImage = pure(props => <Image {...props} />)
export default PureImage
